/** Small monochrome UI drawings, not part of any presentation theme. */
const paths = {
  slide: 'M3 4h14v12H3z M6 8h8 M6 11h5',
  split: 'M3 4h14v12H3z M9 4v12',
  source: 'm7 6-4 4 4 4 m6-8 4 4-4 4 m-2-10-2 12',
  slides: 'M7 5h10 M7 10h10 M7 15h10 M3 5h.5 M3 10h.5 M3 15h.5',
  edit: 'm12 4 4 4 M4 16l4-1 9-9-3-3-9 9-1 4Z',
  save: 'M4 3h10l3 3v11H3V3h1Z M6 3v5h7V3 M6 17v-5h8v5',
  undo: 'M7 4 3 8l4 4 M3 8h8a5 5 0 0 1 0 10',
  add: 'M11 16H3V4h14v6 M15 12v6 M12 15h6',
  media: 'M3 3h14v14H3z m0 11 4-4 4 4 3-3 3 3 M7 6h.5',
  more: 'M4 10h.5 M10 10h.5 M16 10h.5',
  download: 'M10 3v10 m-4-4 4 4 4-4 M3 13v4h14v-4',
  file: 'M11 3H4v14h12V8l-5-5Z M11 3v5h5 M7 11h6 M7 14h4',
  history: 'M3 8a7 7 0 1 1 0 5 M3 3v5h5 M10 6v4l3 2',
  open: 'M3 7V4h5l2 2h7v3 M3 7h5l2 2h8l-3 7H2l1-9Z',
  speaker: 'M3 3h14v10H3z M6 6h4 M6 9h2 M14 6v4 M10 13v4 M6 17h8',
  present: 'M3 3h14v11H3z M8 6l4 2.5L8 11V6Z M10 14v3 M6 17h8',
  previous: 'm11 5-5 5 5 5',
  next: 'm9 5 5 5-5 5',
  fullscreen: 'M3 7V3h4 M13 3h4v4 M17 13v4h-4 M7 17H3v-4',
} as const;

export type WorkspaceIcon = keyof typeof paths;

export function workspaceIcon(name: WorkspaceIcon): SVGSVGElement {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('viewBox', '0 0 20 20');
  svg.setAttribute('width', '16');
  svg.setAttribute('height', '16');
  svg.setAttribute('class', 'workspace-icon');
  svg.setAttribute('fill', 'none');
  svg.setAttribute('stroke', 'currentColor');
  svg.setAttribute('stroke-width', '1.5');
  svg.setAttribute('stroke-linecap', 'round');
  svg.setAttribute('stroke-linejoin', 'round');
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('focusable', 'false');
  const path = document.createElementNS(svg.namespaceURI, 'path');
  path.setAttribute('d', paths[name]);
  svg.append(path);
  return svg;
}

/** Preserve the real label, button semantics and click handler. */
export function withIcon<T extends HTMLElement>(control: T, name: WorkspaceIcon): T {
  control.prepend(workspaceIcon(name));
  return control;
}
